import { useEffect } from 'react';
import { appHeightVar } from '../../styles/pages/onboarding.css';

const handler = () => {
  (document.querySelector(':root') as HTMLElement).style.setProperty(appHeightVar, `${window.innerHeight}px`);
};

const useAppHeight = () => {
  useEffect(() => {
    handler();

    window.addEventListener('resize', handler);

    return () => {
      window.removeEventListener('resize', handler);
    };
  }, []);
};

export default useAppHeight;
